module.exports = __webpack_public_path__ + "static/media/MK.4c014781.png";